export const readOnlyNoticeCopy = {
  materials: "Materials are currently managed through your FYBR contact.",
  sites: "Sites are currently managed through your FYBR contact.",
  orderTypes:
    "Standard order types are provisioned automatically. Specialized order types like Certified Volumetric Inventory require commissioning and criteria to be met, and are managed through your FYBR contact.",
} as const;
